import { connect } from "react-redux";
import { PageBookFound, PageBookFoundWeb } from "senac-components";
import { commonSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import { Wrapper, WrapperStateProps, WrapperDispatchProps } from "./Wrapper";
import {
  Content,
  ContentGroup,
  MenuOptions,
  PageHeaderOptionItem,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import {
  PageBookFoundDispach,
  PageBookFoundState,
} from "senac-components/dist/pages/Mobile/PageBookFound";
import {
  contentSlice,
  loadAndOpenContent,
  loadMoreFromActiveContentFilter,
  showContentDetail,
} from "../store/reducers/contentSlice";
import { PageBookFoundWebDispach } from "senac-components/dist/pages/Web/PageBookFound";
import { filterContent } from "../store/reducers/common";

const mapState = (state: RootState, props: any) => {
  const Component =
    window.innerWidth >= 1024 ? PageBookFoundWeb : PageBookFound;
  var allContent = state.contentState.allContents;
  var contents: Content[] | undefined = undefined;

  if (state.contentState.contentFromFilter) {
    contents = state.contentState.contentFromFilter
      .map((p) => allContent.find((c) => c.uid == p))
      .filter((p) => p != undefined) as Content[];
  }

  let result: PageBookFoundState & WrapperStateProps & { fetching?: boolean } = {
    title: state.contentState.activeFilter?.query ?? "",
    contents: contents,
    element: Component,
    authenticatedUser: state.userState.user != undefined,
    showButtonMore: state.contentState.activeFilter?.customQuery ? true : false,
    totalContents: state.contentState.totalContentsFromFilter,
    fetching: state.contentState.activeFilter?.processing
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch, props: any) => {
  const result: PageBookFoundDispach & WrapperDispatchProps & Partial<PageBookFoundWebDispach> = {
    onClickContent: (content: Content) =>
      dispatch(showContentDetail(content.uid)),
    onClickContentDetail: (content: Content) =>
    dispatch(loadAndOpenContent(content.uid)),
    onChangeSearchParams(params) {
      if (!params) return;

      console.log("......",params)
      var value = params.get("q");
      if (value == null) return;

      console.log("paras:" , value)
      dispatch(contentSlice.actions.contentFilter({ query : value}))
    },
    onChangeParams: (params: any) => {
      
    },
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: PageHeaderOptionItem) =>
      dispatch(commonSlice.actions.goToPageOption(option)),
    onSelectedNavigationPageOption: (option: MenuOptions) =>
      dispatch(commonSlice.actions.goToPage(option)),
    onChangeFilter: (filter) => {
      if (filter.query == undefined) return;
      const filterData = { query: filter.query };

      dispatch(filterContent(filterData));
      // dispatch(contentSlice.actions.contentFilter(filterData))
    },
    onClickShowMore: () => {
      dispatch(loadMoreFromActiveContentFilter());
    },
  };
  return result;
};

const WPageBookFound = connect(mapState, mapDispatch)(Wrapper);

export { WPageBookFound };
